import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const containerStyles = {
  position: 'fixed',
  right: '100px',
  top: '100px',
  zIndex: '1000',
  padding: '15px',
  background: '#ff7a59',
  color: '#fff',
  borderRadius: '3px'
};
const labelStyles = {
  marginRight: '3px'
};
const rowStyles = {
  display: 'flex',
  justifyContent: 'space-between'
};
const RegressionTracker = ({
  isTrackingVisibility,
  isAutoToggling,
  toggleTrackVisibility,
  setAutoToggle
}) => {
  return /*#__PURE__*/_jsxs("div", {
    style: containerStyles,
    children: [/*#__PURE__*/_jsxs("div", {
      style: rowStyles,
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: "toggleTrackVisibility",
        style: labelStyles,
        children: "Toggle Visibility Tracking"
      }), /*#__PURE__*/_jsx("input", {
        id: "toggleTrackVisibility",
        type: "checkbox",
        checked: isTrackingVisibility,
        onChange: toggleTrackVisibility
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: rowStyles,
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: "setAutoToggle",
        style: labelStyles,
        children: "Toggle Visibility Every 2s"
      }), /*#__PURE__*/_jsx("input", {
        id: "setAutoToggle",
        type: "checkbox",
        checked: isAutoToggling,
        onChange: setAutoToggle
      })]
    })]
  });
};
if (process.env.NODE_ENV !== 'production') {
  RegressionTracker.propTypes = {
    isTrackingVisibility: PropTypes.bool.isRequired,
    isAutoToggling: PropTypes.bool.isRequired,
    toggleTrackVisibility: PropTypes.func.isRequired,
    setAutoToggle: PropTypes.func.isRequired
  };
}
export default RegressionTracker;